import { initialColsData } from '../constants/constants'

const hasValue = (item) => item && typeof item === 'object' && item.value

const isColumnsObject = (data) => data && typeof data === 'object' && !Array.isArray(data)

const normalizeChecked = (checked, value, fallbackChecked) => {
  if (Array.isArray(checked)) {
    return checked.length > 0 ? [value] : []
  }

  return fallbackChecked ? [value] : []
}

const indexColumnsByValue = (columns) => {
  if (!Array.isArray(columns)) return new Map()

  return columns.reduce((index, column) => {
    if (hasValue(column)) index.set(column.value, column)
    return index
  }, new Map())
}

export const normalizeOrganizationColumns = (data = {}, template = initialColsData) => {
  const source = isColumnsObject(data) ? data : {}

  return Object.keys(template).reduce((normalized, tableKey) => {
    const existingColumns = indexColumnsByValue(source[tableKey])

    normalized[tableKey] = template[tableKey].map((templateColumn) => {
      const existingColumn = existingColumns.get(templateColumn.value)
      const fallbackChecked = Array.isArray(templateColumn.checked) && templateColumn.checked.length > 0

      return {
        ...templateColumn,
        ...(existingColumn || {}),
        label: templateColumn.label,
        value: templateColumn.value,
        checked: normalizeChecked(existingColumn?.checked, templateColumn.value, fallbackChecked),
      }
    })

    return normalized
  }, {})
}

export const normalizeUserColumns = (data = {}, organizationColumns = {}, template = initialColsData) => {
  const normalizedOrgColumns = normalizeOrganizationColumns(organizationColumns, template)
  const normalizedUserColumns = normalizeOrganizationColumns(data, template)

  return Object.keys(template).reduce((normalized, tableKey) => {
    const orgColumns = indexColumnsByValue(normalizedOrgColumns[tableKey])

    normalized[tableKey] = normalizedUserColumns[tableKey].map((userColumn) => {
      const orgColumn = orgColumns.get(userColumn.value)

      return {
        ...userColumn,
        checked: orgColumn?.checked?.length ? userColumn.checked : [],
      }
    })

    return normalized
  }, {})
}

export const buildUserColumnsFromOrganization = (data = {}, organizationColumns = {}, template = initialColsData) => {
  const normalizedOrgColumns = normalizeOrganizationColumns(organizationColumns, template)
  const normalizedUserColumns = normalizeOrganizationColumns(data, template)

  return Object.keys(template).reduce((normalized, tableKey) => {
    const userColumns = indexColumnsByValue(normalizedUserColumns[tableKey])

    normalized[tableKey] = normalizedOrgColumns[tableKey].map((orgColumn) => {
      const userColumn = userColumns.get(orgColumn.value) || orgColumn

      return {
        ...userColumn,
        label: orgColumn.label,
        value: orgColumn.value,
        checked: orgColumn.checked.length ? [orgColumn.value] : [],
      }
    })

    return normalized
  }, {})
}

export const isColumnChecked = (columns = {}, tableKey, value) => {
  const tableColumns = Array.isArray(columns[tableKey]) ? columns[tableKey] : []
  const column = tableColumns.find((item) => item.value === value)

  return !!column?.checked?.length
}

export const areColumnsEqual = (first, second) => JSON.stringify(first || {}) === JSON.stringify(second || {})
